// Copyright 2025. WebPros International GmbH. All rights reserved.

import { createCustomAction } from 'typesafe-actions';
import * as types from 'common/modules/app/lastUsedSshKeys/constants';

export const setLastUsedSshKeys = createCustomAction(
    types.SET_LAST_USED_SSH_KEYS,
    (data: number[]) => ({ payload: data })
);
